<h2 mat-dialog-title class="popup-header">Select upscaling rock image file</h2>

@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

@if (!isLoading) {
  <div class="popup-content">
    <mat-form-field appearance="outline">
      <mat-label>Search upscaling rock images</mat-label>
      <input
        matInput
        [(ngModel)]="searchInput"
        (ngModelChange)="filterRockImageFiles()"
        placeholder="Enter rock image file name"
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      @if (filteredRockImageFiles.length) {
        <div class="scroll">
          <table class="mat-elevation-z2 full-width">
            <thead>
              <tr>
                <th>File Name</th>
                <th>Uploaded By</th>
                <th>Created At</th>
                <th>Phases</th>
              </tr>
            </thead>
            <tbody>
              @for (file of filteredRockImageFiles; track file) {
                <tr
                  (click)="onRowClick(file)"
                  [class.selected]="file.fileName === selectedRockImageFile?.fileName"
                  >
                  <td>{{ file.fileName | removeExtension }}</td>
                  <td>{{ file.userName }}</td>
                  <td>{{ file.createdAt | date : 'short' }}</td>
                  <td>{{ file.numberOfPhases || 'N/A' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else if (rockImageFiles.length) {
        <div class="no-results">
          <mat-icon class="no-results-icon">info</mat-icon>
          <p>No data matching the filter value</p>
        </div>
      } @else {
        <div class="no-results">
          <mat-icon class="no-results-icon">info</mat-icon>
          <p>No upscaling rock image files available</p>
        </div>
      }
    </div>
  }

  @if (!isLoading) {
    <div class="popup-actions">
      <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
      <button class="btn btn-primary" [disabled]="!selectedRockImageFile" (click)="onSelect()">
        Select
      </button>
    </div>
  }
